import { SxProps } from '@mui/material'

/**
 * Allows us to create custom sx props for re-usability if needed.
 * For more info, {@see https://mui.com/system/getting-started/the-sx-prop/#passing-the-sx-prop}.
 */
export const customSxProps = (sx: SxProps) => {
  return Array.isArray(sx) ? sx : [sx]
}
